export const updateSelectedNiches = (id: string, selected: string[]) => {
  let values;

  if (selected.indexOf(id) >= 0) {
    values = selected.filter(x => x !== id);
  } else {
    values = [...selected, id];
  }

  return values;
};
